import axios from "axios";
import { environment } from "../config.env";

const ENDPOINT_DOMAIN =
  process.env.REACT_APP_ENDPOINT_DOMAIN || environment.endpoint_domain || "";

axios.defaults.baseURL = ENDPOINT_DOMAIN;
// axios.defaults.headers.common['Authorization'] = localStorage.getItem('pg_access_token');

export function postSearchPatient(pid, fname, lname) {
  return new Promise((resolve) => {
    const path = "/api/v1/medical/permission/searchPatient";
    let body = {
      pid: pid,
      fname: fname,
      lname: lname,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(path, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

//check check credential
export function postRequestCredential(uid) {
  return new Promise((resolve) => {
    const path = "/api/v1/medical/permission/requestCredential";
    let body = {
      uid: uid,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(path, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function getSiamScanCard() {
  return new Promise((resolve) => {
    const path = "/api/v1/medical/document/SiamID23_Setup.zip";
    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(path, { headers: header, responseType: "blob" })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'SiamID23_Setup.zip');
        document.body.appendChild(link);
        link.click();
        link.remove();
        resolve(true);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function getSiamScanCardManual() {
  return new Promise((resolve) => {
    const path = "/api/v1/medical/document/DMSC_manaul.pdf";
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(path, { headers: header, responseType: "blob" })
      .then((res) => {
        if (res.data) {
          const fileBlob = new Blob([res.data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(fileBlob);
          window.open(url, '_blank');
          window.URL.revokeObjectURL(url);
          resolve(true);
        } else {
          resolve(false);
        }
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function postRequestPermission(uid) {
  return new Promise((resolve) => {
    const path = "/api/v1/medical/permission/requestPermission";
    let body = {
      uid: uid,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(path, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function postRequestPermissionDoctor(
  personalDataCID,
  permissionState
) {
  return new Promise((resolve) => {
    const path =
      "/api/v1/medical/permission/requestPermissionByDoctor";
    let body = {
      patient: personalDataCID,
      permission: permissionState,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(path, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function postRequestPermissionHospitalTeam(
  doctorRequest,
  personalDataCID,
  permissionState
) {
  return new Promise((resolve) => {
    const path =
      "/api/v1/hospital_personal/permission/requestPermissionByHospitalTeam";
    let body = {
      doctor: doctorRequest,
      patient: personalDataCID,
      permission: permissionState,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(path, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function postPatientSearch(
  pid, fullname
) {
  return new Promise((resolve) => {
    const path =
      "/api/v1/public/permission/patients_search";
    let body = {
      pid,
      fullname
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(path, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function getDocument(page, numberPerPage, sort, order) {
  return new Promise((resolve) => {
    const path = "/api/v1/medical/document/getDocument";
    let params = {
      page: page,
      number_per_page: numberPerPage,
    };
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(path, { headers: header, params })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function getRequestPermission(status, page, number_per_page) {
  return new Promise((resolve) => {
    const path = "/api/v1/medical/permission/getRequestPermission";
    let body = {
      status: status,
      page: page,
      number_per_page: number_per_page,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(path, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function removeDocument(documentId) {
  return new Promise((resolve) => {
    const path = "/api/v1/medical/document/removeDocument";
    let body = {
      document_id: documentId,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(path, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}
export function addDocument(formDataBody) {
  return new Promise((resolve) => {
    let url = `/api/v1/medical/document/addDocument`;
    let header = {
      "Content-Type": "multipart/form-data",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, formDataBody, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function addGuideline(
  titleValue,
  title,
  detail,
  pined,
  active,
  publishStartDate,
  publishEndDate
) {
  return new Promise((resolve) => {
    let url = `/api/v1/medical/guideline/addGuideLine`;
    let body = {
      type: titleValue,
      title: title,
      detail: detail,
      active: active,
      pined: pined,
      publish_start_date: publishStartDate,
      publish_end_date: publishEndDate,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function updateGuideline(
  guideline_id,
  titleValue,
  title,
  detail,
  pined,
  active,
  publishStartDate,
  publishEndDate
) {
  return new Promise((resolve) => {
    let url = `/api/v1/medical/guideline/updateGuideline`;
    let body = {
      guideline_id: guideline_id,
      type: titleValue,
      title: title,
      detail: detail,
      active: active,
      pined: pined,
      publish_start_date: publishStartDate,
      publish_end_date: publishEndDate,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getGuideline(page, numberPerPage, filters, sort, order) {
  return new Promise((resolve) => {
    let url = `/api/v1/medical/guideline/getGuideline`;
    let params = {
      page: page,
      number_per_page: numberPerPage,
    };

    if (filters) params.filters = filters;
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { headers: header, params })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}
export function removeGuideline(guidelineId) {
  return new Promise((resolve) => {
    let url = `/api/v1/medical/guideline/removeGuideline`;
    let body = {
      guideline_id: guidelineId,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getLabInformation(credentialToken) {
  return new Promise((resolve) => {
    let url = `/api/v1/medical/lab/getLabInformation`;
    let body = {
      credential_token: credentialToken,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getDrugAllergyGene(credentialToken) {
  return new Promise((resolve) => {
    let url = `/api/v1/medical/lab/getDrugAllergyGene`;
    let body = {
      credential_token: credentialToken,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}
export function getDrugDegradingGene(credentialToken) {
  return new Promise((resolve) => {
    let url = `/api/v1/medical/lab/getDrugDegradingGene`;
    let body = {
      credential_token: credentialToken,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getActivePermission() {
  return new Promise((resolve) => {
    let url = `/api/v1/medical/permission/getActivePermission`;
    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

// ค้นหาผู้ป่วย

export function getDataPatient(data) {
  return new Promise((resolve) => {
    let url = `/api/v1/medical/permission/searchPatient2`;
    let body = data;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getDataPatientByHospital(data) {
  return new Promise((resolve) => {
    let url = `/api/v1/hospital_personal/permission/searchPatient2`;
    let body = data;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getDataDoctorList(data) {
  return new Promise((resolve) => {
    let url = `/api/v1/public/permission/doctor_list`;
    let body = data;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getDataDoctorListAll(data) {
  return new Promise((resolve) => {
    let url = `/api/v1/public/permission/doctor_list_all`;
    let body = data;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getDataPatientByDoctor() {
  return new Promise((resolve) => {
    let url = `/api/v1/medical/permission/searchPatientByDoctor`;
    let body = {};
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getGuideLineDetail(id) {
  return new Promise((resolve) => {
    let url = `/api/v1/medical/guideline/getGuideLineDetail`;
    let body = {
      id: id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

//verify by thai id
export function getOauthVerifyIdentityThaiID(role) {
  return new Promise((resolve) => {
    const path = `/api/v1/medical/verify-identity/getOauthVerifyIdentityThaiID/web/${role}`;

    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(path, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}
